// Kinds of organization the website wizard offers, grouped for the picker.
// Ids match backend/org_types.py, which turns each into words for the builder.
export const ORG_TYPE_GROUPS = [
  {
    label: 'Faith & community',
    types: [
      { id: 'church', label: 'Church / Ministry' },
      { id: 'nonprofit', label: 'Non-Profit / Charity' },
      { id: 'school', label: 'School / Education' },
      { id: 'daycare', label: 'Daycare / Preschool' },
      { id: 'club', label: 'Club / Association' },
      { id: 'sports', label: 'Sports Team / League' },
      { id: 'community', label: 'Community Group / HOA' },
    ],
  },
  {
    label: 'Food, health & beauty',
    types: [
      { id: 'restaurant', label: 'Restaurant / Cafe' },
      { id: 'catering', label: 'Food Truck / Catering' },
      { id: 'salon', label: 'Salon / Spa / Barber' },
      { id: 'fitness', label: 'Gym / Fitness' },
      { id: 'medical', label: 'Medical / Dental' },
      { id: 'counseling', label: 'Counseling / Therapy' },
    ],
  },
  {
    label: 'Trades & local services',
    types: [
      { id: 'contractor', label: 'Construction / Contractor' },
      { id: 'homeservices', label: 'Home Services' },
      { id: 'auto', label: 'Auto Repair / Detailing' },
      { id: 'realestate', label: 'Real Estate' },
      { id: 'legal', label: 'Law Firm / Legal' },
      { id: 'services', label: 'Professional Services' },
      { id: 'coaching', label: 'Consultant / Coach' },
    ],
  },
  {
    label: 'Shops, creative & personal',
    types: [
      { id: 'retail', label: 'Retail Store' },
      { id: 'onlinestore', label: 'Online Store' },
      { id: 'creative', label: 'Photographer / Artist' },
      { id: 'events', label: 'Event Venue / Wedding' },
      { id: 'author', label: 'Author / Speaker / Musician' },
      { id: 'blog', label: 'Blog / Personal' },
      { id: 'portfolio', label: 'Portfolio / Resume' },
      { id: 'other', label: 'Something else' },
    ],
  },
];

export const ORG_TYPES = ORG_TYPE_GROUPS.flatMap(g => g.types);

// "Something else" sends what the customer typed, so the builder hears
// "dog groomer" rather than nothing.
export function orgTypeForBuild(form) {
  const other = (form.business_type_other || '').trim();
  return form.business_type === 'other' && other ? other.slice(0, 60) : form.business_type;
}
